<template>
  <div name="hres8ax-deduction">
    <div class="box-tab2">
      <div id="accordion"> 

        <hres8ax-deduction-tab1 :labels="labels"
                                :detailDeduction="detailDeduction.table1"
                                :detailDeductionTable1="detailDeductionTable1"/>
        <hres8ax-deduction-tab2 :labels="labels"
                                :detailDeduction="detailDeduction.table2"
                                :detailDeductionTable2="detailDeductionTable2"/>
      </div>
    </div>
  </div>
</template>

<script>
import hres8axDeductionTab1 from 'components/hres8ax/deduction_1'
import hres8axDeductionTab2 from 'components/hres8ax/deduction_2'

export default {
  name: 'hres8ax-deduction',
  props: [ 'labels',
    'detailDeduction',
    'detailDeductionTable1',
    'detailDeductionTable2'
  ],
  components: {
    hres8axDeductionTab1,
    hres8axDeductionTab2
  }
}
</script>



// WEBPACK FOOTER //
// deduction.vue?50ddd2d5